import React, { useState, useMemo, useEffect } from "react";
import { Button } from "./Button";
import { ReactComponent as ArrowRight } from "../../assets/icons/arrowright.svg";
import { ReactComponent as ArrowLeft } from "../../assets/icons/arrowleft.svg";
import { ReactComponent as Spinner } from "../../assets/icons/spinner.svg";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useGetCompanyQuery, useGetCompanyRequestStatusMutation, useUpdateCompanyRequestStatusMutation } from "../../../src/store/Company/companyApiSlice"
export const BackNextButton = ({ onPrev, onNext, onSkip, isLoading, clear = false, setClearClicked, clearClicked, disable, proceed = false, onProceed }) => {
  const [updateCompanyRequestStatus] = useUpdateCompanyRequestStatusMutation();

  const { userInfo, token, isLoggedIn } = useSelector((state) => state.auth);
  const { id } = useParams();
  const { data, isError, error, refetch } = useGetCompanyQuery({
    companyId: id,
    token,
  });

  const [companyVerificationStatus, setcompanyVerificationStatus] =
    useState("pending");
  const [getCompanyRequestStatus] = useGetCompanyRequestStatusMutation();

  const [requestID, setrequestID] = useState(null);
  useEffect(() => {
    let userindividualID = localStorage.getItem("userindividualID");

    if (userindividualID) {
      const companyStatus = async () => {
        let dataval = await getCompanyRequestStatus({
          companyID: id,
          individualID:
            userindividualID ||
            data?.userCompany[0]?.individualID?.individualID,
          token,
        });
        if (dataval) {
          let statusValue = dataval.data?.filter(
            (item) => item?.companyID?.companyID == id
          );
          if (statusValue?.length > 0) {
            let companyStatus = statusValue[statusValue.length - 1];
            setcompanyVerificationStatus(companyStatus?.status);
            setrequestID(companyStatus?.requestID);

          }
        }
      };
      companyStatus();
    }
  }, [data]);

  const handleClear = () => {
    setClearClicked(!clearClicked);
  }

  return (
    <div className="flex justify-between gap-2">
      <Button
        classes="gobackBtn inline-flex items-center justify-start mr-2 gap-4 text-primaryText font-bold w-full"

      >
        <ArrowLeft onClick={onPrev} />
        <span className="relative" onClick={onPrev}>Go Back</span>
      </Button>
      <div className="actionButtons">
        {clear && !proceed && <Button classes={`skipbtn relative group w-full py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center gap-4 `} onClick={handleClear} onMouseDown={() => setClearClicked(false)}>
          <span className="relative">
            Clear
          </span>
        </Button>}
        {<Button classes={`skipbtn relative group w-full py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center gap-4 `} onClick={onSkip}>
          <span className="relative">
            Skip
          </span>
        </Button>}
        {!proceed && <Button
          classes={`relative group w-full py-3 px-5 text-center text-sm font-semibold text-white rounded-md  inline-flex items-center justify-center gap-4 ${disable ? "bg-disable cursor-not-allowed" : "bg-primary cursor-pointer"}`}
          onClick={onNext}
          isInvalid={disable}
        >
          <span className="relative">
            {isLoading ? <Spinner /> : "Save & Continue"}
          </span>
          <ArrowRight />
        </Button>}
        {proceed && <Button
          classes={`relative group w-full py-3 px-5 text-center text-sm font-semibold text-white rounded-md  inline-flex items-center justify-center gap-4 ${disable ? "bg-disable cursor-not-allowed" : "bg-primary cursor-pointer"}`}
          onClick={onProceed}
          isInvalid={disable}
        >
          <span className="relative">
            {isLoading ? <Spinner /> : "Proceed"}
          </span>
          <ArrowRight />
        </Button>}
      </div>
    </div>
  );
};
